import { defineNuxtPlugin } from "#app";

// 숫자를 포맷팅하는 함수
export const numberFormat = (
  value: number | string | undefined | null,
): string => {
  if (value === undefined || value === null || value === "") {
    // 값이 없거나 비어있다면 빈 문자열 반환
    return "";
  }

  if (typeof value === "string") {
    // 문자열 값을 처리 (문자열이 숫자 포맷인지 확인)

    // ,(컴마)가 포함된 경우 제거하고 숫자로 변환
    if (value.includes(",")) {
      value = value.replace(/,/g, ""); // 컴마 제거
    }

    // 제거 후 숫자 변환 가능하면 변환
    if (!isNaN(Number(value))) {
      value = Number(value);
    } else {
      // 숫자가 아닌 경우 그대로 문자열 반환
      return value;
    }
  }

  if (typeof value === "number") {
    // 숫자인 경우 Intl.NumberFormat으로 포맷팅
    return new Intl.NumberFormat().format(value);
  }

  // 모든 경우를 처리한 후 기본값 반환
  return "";
};

// Nuxt 플러그인 정의
export default defineNuxtPlugin((nuxtApp) => {
  // numberFormat 함수 글로벌로 등록
  nuxtApp.provide("numberFormat", numberFormat);
});
